import axios from 'axios';
import { API_URL } from '../config/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  if (!token) throw new Error('No hay token de autenticación. Por favor, inicia sesión.');
  return { Authorization: `Token ${token}` };
};

const BASE = `${API_URL}/api/empresas`;

export const empresasApi = {
  listar: (params = {}) =>
    axios.get(`${BASE}/`, { headers: getAuthHeaders(), params }).then((r) => r.data),

  buscar: (q = '') =>
    axios
      .get(`${BASE}/buscar/`, { headers: getAuthHeaders(), params: { search: q } })
      .then((r) => r.data),

  obtener: (id) =>
    axios.get(`${BASE}/${id}/`, { headers: getAuthHeaders() }).then((r) => r.data),

  crear: (data) =>
    axios.post(`${BASE}/`, data, { headers: getAuthHeaders() }).then((r) => r.data),

  actualizar: (id, data) =>
    axios.put(`${BASE}/${id}/`, data, { headers: getAuthHeaders() }).then((r) => r.data),

  eliminar: (id) =>
    axios.delete(`${BASE}/${id}/`, { headers: getAuthHeaders() }).then((r) => r.data),

  descargarPlantilla: () =>
    axios
      .get(`${BASE}/plantilla-excel/`, { headers: getAuthHeaders(), responseType: 'blob' })
      .then((r) => {
        const url = window.URL.createObjectURL(new Blob([r.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'plantilla_empresas.xlsx');
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }),

  importarExcel: (archivo) => {
    const fd = new FormData();
    fd.append('archivo', archivo);
    return axios
      .post(`${BASE}/importar-excel/`, fd, {
        headers: { ...getAuthHeaders(), 'Content-Type': 'multipart/form-data' },
      })
      .then((r) => r.data);
  },

  sincronizarDGII: (forzar = false) =>
    axios
      .post(`${BASE}/sincronizar-desde-dgii/${forzar ? '?forzar=1' : ''}`, {}, {
        headers: getAuthHeaders(),
      })
      .then((r) => r.data),
};
